module.exports = __webpack_public_path__ + "img/marca.1b9d3a06.png";